import React, { Component } from 'react';

import BlocCta from './BlocCta';

import '../css/components/Showcase.css';

import imageCic from '../images/cic.jpg';
import imagePagesJaunes from '../images/pagesjaune.jpg';
import imageAgfa from '../images/agfa.jpg';
import imageJolotte from '../images/jolotte.jpg';
import imageGigz from '../images/gigz.jpg';


class Showcase extends Component {
  constructor (props) {
    super(props)
    this.large = props.large ? (props.large === 'true') : false;
  }

  render() {
    return (
            <section className="bloc-showcase">
                <div className="colonne">
                    <BlocCta
                        image={ {"src": imageCic, "alt": "cic"} }
                        title={ "CIC Sud-Ouest" }
                        subtitle={ "serious game" }
                        link={ {"href": "/projet/cic-serious-game", "label": "Découvrir le projet"} }
                     />
                    {
                        this.large ? (
                            <BlocCta
                                image={ {"src": imageCic, "alt": "cic"} }
                                title={ "CIC Sud-Ouest" }
                                subtitle={ "serious game" }
                                link={ {"href": "/projet/cic-serious-game", "label": "Découvrir le projet"} }
                             />
                         ) : null
                    }
                    {
                        this.large ? (
                            <BlocCta
                                extraClassName={ "est-petit" }
                                image={ {"src": imagePagesJaunes, "alt": "pagesjaune"} }
                                title={ "Pages Jaunes" }
                                subtitle={ "communication interne" }
                             />
                         ) : null
                    }
                </div>
                <div className="colonne">
                    <BlocCta
                        extraClassName={ "est-petit" }
                        image={ {"src": imagePagesJaunes, "alt": "pagesjaune"} }
                        title={ "Pages Jaunes" }
                        subtitle={ "communication interne" }
                     />
                    <BlocCta
                        image={ {"src": imageAgfa, "alt": "agfa"} }
                        title={ "AGFA Healthcare" }
                        subtitle={ "refonte de l'identité de leurs produits" }
                        link={ {"href": "/projet/agfa", "label": "Découvrir le projet"} }
                     />
                    {
                        this.large ? (
                            <BlocCta
                                image={ {"src": imageAgfa, "alt": "agfa"} }
                                title={ "AGFA Healthcare" }
                                subtitle={ "refonte de l'identité de leurs produits" }
                                link={ {"href": "/projet/agfa", "label": "Découvrir le projet"} }
                             />
                         ) : null
                    }
                </div>
                <div className="colonne">
                    <BlocCta
                        extraClassName={ "est-petit" }
                        image={ {"src": imageGigz, "alt": "gigz"} }
                        title={ "Gigz" }
                        subtitle={ "application mobile" }
                     />
                    <BlocCta
                        image={ {"src": imageJolotte, "alt": "jolotte"} }
                        title={ "Jolotte" }
                        subtitle={ "application mobile" }
                        link={ {"href": "/projet/jolotte", "label": "Découvrir le projet"} }
                     />
                    {
                        this.large ? (
                            <BlocCta
                                extraClassName={ "est-petit" }
                                image={ {"src": imageGigz, "alt": "gigz"} }
                                title={ "Gigz" }
                                subtitle={ "application mobile" }
                             />
                         ) : null
                    }
                    {
                        this.large ? (
                            <BlocCta
                                image={ {"src": imageJolotte, "alt": "jolotte"} }
                                title={ "Jolotte" }
                                subtitle={ "application mobile" }
                                link={ {"href": "/projet/jolotte", "label": "Découvrir le projet"} }
                             />
                         ) : null
                    }
                </div>
            </section>
    );
  }
}

export default Showcase;



// WEBPACK FOOTER //
// ./src/components/Showcase.js